import React, { useContext, useEffect } from 'react';
import store from '../store';
import { Switch, Route } from 'react-router-dom';
import routes from '../routes';
import SimpleReactLightbox from "simple-react-lightbox";
// Verification
import { displayNameIsNull } from '../constants/verifications';
// Components
import AppBar from '../components/AppBar';
import ChangeDisplayNameModal from '../components/ChangeDisplayNameModal';
import ChangeEmailModal from '../components/ChangeEmailModal';
import ChangePasswordModal from '../components/ChangePasswordModal';
import DeleteAccountModal from '../components/DeleteAccountModal';
import SendVerificationEmailModal from '../components/SendVerificationEmailModal';
import TermsModal from '../components/TermsModal';

// Styles
import { CssBaseline } from '@material-ui/core';

function App() {
  const { state, reducers } = useContext(store);

  useEffect(() => {
    reducers.onAuthStateChanged();
    reducers.getStoryList();
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (displayNameIsNull(state.user)) {
      reducers.handleModals('changeDisplayName', true);
      return;
    }
    //eslint-disable-next-line
  }, [state.user])

  return (
    <SimpleReactLightbox>
      <CssBaseline />
      <AppBar />
      <Switch>
        {routes.map((route, i) =>
          <Route key={i} exact={route.exact} path={route.path} component={route.component} />
        )}
      </Switch>
      <ChangeDisplayNameModal />
      <ChangeEmailModal />
      <ChangePasswordModal />
      <DeleteAccountModal />
      <SendVerificationEmailModal />
      <TermsModal />
    </SimpleReactLightbox>
  );
}

export default App;
